<template>
    <div class="overflow-hidden">
        <SmuToast :toasts="toasts" />
        <SmuMovingBackground context="production" />
        <SmuHeader
            :title="$t('frontend.production_title')"
            :subtitle="$t('frontend.production_administration')"
            class="mb-0!"
        >
            <template #right-side>
                <LanguageDropdown />
            </template>
        </SmuHeader>
        <div class="-m-12 flex min-h-screen items-center justify-center py-16">
            <div
                class="z-10 flex w-1/2 max-w-5xl min-w-96 flex-col items-center justify-center"
            >
                <div class="w-full">
                    <slot />
                </div>
            </div>
        </div>
        <div class="fixed inset-x-0 bottom-0 flex items-end justify-center p-4">
            <div
                class="fixed bottom-0 flex justify-center p-4 text-dark-text shadow-lg"
            >
                <PageDefaultFooter />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {
    SmuHeader,
    SmuMovingBackground,
    SmuToast,
    useToast,
} from "@smakecloud/smake-ui";

const { toasts } = useToast();
</script>
